/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_LoadingInputs */



/**
* | output |
* | --- |
* | "Checking your licence…" |
*
* @param {License_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_loading = /** @type {((inputs?: License_LoadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_LoadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vérification de votre licence…")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lizenz wird geprüft…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Verifica della licenza…")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверка лицензии…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprobando tu licencia…")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在检查许可证…")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライセンスを確認しています…")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपका लाइसेंस जाँचा जा रहा है…")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A verificar a licença…")
	return /** @type {LocalizedString} */ ("Checking your licence…")
});